/** Copies `value` to the clipboard. Resolves `false` instead of throwing when the Clipboard API is unavailable or denied. */
export async function copyToClipboard(value: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(value);
    return true;
  } catch {
    return false;
  }
}
